import React from 'react';
import { motion } from 'framer-motion';
import { DocumentPen, PhoneSignal, SteeringWheel } from './Icons';
interface HowItWorksProps {
  lang: 'en' | 'es';
}
export function HowItWorks({
  lang
}: HowItWorksProps) {
  const content = {
    en: {
      title: 'How It Works',
      steps: [{
        icon: DocumentPen,
        title: 'Fill the Form',
        desc: "Tell Simon what you're looking for"
      }, {
        icon: PhoneSignal,
        title: 'Simon Contacts You',
        desc: 'Same-day personal response guaranteed'
      }, {
        icon: SteeringWheel,
        title: 'Drive Your Car',
        desc: 'Get the best deal and hit the road'
      }]
    },
    es: {
      title: 'Cómo Funciona',
      steps: [{
        icon: DocumentPen,
        title: 'Llena el Formulario',
        desc: 'Dile a Simon lo que buscas'
      }, {
        icon: PhoneSignal,
        title: 'Simon te Contacta',
        desc: 'Respuesta personal el mismo día'
      }, {
        icon: SteeringWheel,
        title: 'Maneja tu Auto',
        desc: 'Obtén el mejor trato y sal a rodar'
      }]
    }
  };
  const t = content[lang];
  return <section className="border-t border-border bg-background px-6 py-24" data-id="element-37">
      <div className="mx-auto max-w-5xl" data-id="element-38">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20 text-center text-3xl font-bold md:text-4xl" data-id="element-39">
          {t.title}
        </motion.h2>

        <div className="relative" data-id="element-40">
          <div className="absolute left-[15%] right-[15%] top-10 z-0 hidden border-t-2 border-dashed border-border md:block" data-id="element-41" />
          <div className="relative z-10 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-6" data-id="element-42">
            {t.steps.map((step, index) => <motion.article key={step.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-43">
                <div className="relative mb-6 flex h-20 w-20 items-center justify-center rounded-full border-2 border-border bg-card" data-id="element-44">
                  <span className="absolute -right-3 -top-3 flex h-8 w-8 items-center justify-center rounded-full border-4 border-background bg-primary text-sm font-bold text-white" data-id="element-45">
                    {index + 1}
                  </span>
                  <step.icon className="text-white" size={32} data-id="element-46" />
                </div>
                <h3 className="mb-3 text-xl font-semibold" data-id="element-47">{step.title}</h3>
                <p className="max-w-[250px] text-[#aaaaaa]" data-id="element-48">{step.desc}</p>
              </motion.article>)}
          </div>
        </div>
      </div>
    </section>;
}